import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./ssn-check.component.css', './thankyou.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class ThankyouComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  ssndepostList;
  isChecked = false;
  elem4;
  elem5;
  elem6;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  timer;
  time = 2000;
  timeTrue = false;
  hideHome = false;
  vishome;
  userObj = {
    emailId: '',
    password: '',
  };
  url = environment.api_url;
  previousUrl = '';
  url1 = '';
  oldURL = '';
  hgAccountID: string;
  forgotModalVisible = false;

  constructor(
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private _scrollToService: ScrollToService,
    private http: HttpClient,
    private title: Title
  ) {
    // console.log.log(this.recommendationService.signupProduct);
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
    this.ssndepostList = {
      value4: false,
      value5: false,
      value6: false,
    };
    this.hideHome = true;
    var vishome = this.hideHome;
    sessionStorage.setItem('hideHome', JSON.stringify(vishome));
    this.deviceWidth = window.innerWidth;
  }

  ngOnInit() {}

  gotoHome() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      const hg_accountId = window.location.href.split('/').pop();
      sessionStorage.removeItem('APIESIIDValues');
      sessionStorage.removeItem('esiidValue');
      sessionStorage.removeItem('recommendedProducts');
      sessionStorage.removeItem('userResponse');
      this.router.navigate(['user-settings', hg_accountId]);
    } else {
      this.router.navigate(['/']);
    }
  }
  shop(selectedOption) {
    if (selectedOption === 'prepaid') {
      this.recommendationService.ssnFailedText = selectedOption;
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders = [];
        sessionStorage.setItem(
          'ssnFailedEnergyProviders',
          JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
        );
      }
    } else {
      this.recommendationService.ssnFailedText = selectedOption;
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders =
          this.ssnFailedEnergyProvidersList;
      }
      this.recommendationService.ssnFailedEnergyProviders.push(
        this.selectedProduct.energy_provider
      );
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
      );
    }
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  createAccount(event, myForm) {
    const body = new HttpParams();
    body.append('userObj', JSON.stringify(this.userObj));
    body.append('a', 'login');
    this.http
      .get(this.url + '/login', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result.statusCode === '002') {
          this.userObj.emailId = '';
          this.userObj.password = '';
        } else {
          this.hgAccountID = result.data.hg_accountId;
          this.setAdminTitle(result.data.userRole);
          this.saveQuestionnaireObject(
            sessionStorage.getItem('userResponse'),
            result.data
          );
          myForm.resetForm();
          sessionStorage.setItem('userObj', JSON.stringify(result.data));
          this.oldURL = sessionStorage.getItem('path');
          this.checkUserRoles(result.data);
        }
      });
  }

  saveQuestionnaireObject(questionnarieObj, data) {
    //const body = new HttpParams();
    let percentage = sessionStorage.getItem('percentage');
    if (questionnarieObj && data) {
      const body = new HttpParams()
      .append('questionnarieObj', questionnarieObj)
      .append('userObj', JSON.stringify(data))
      .append('percentage', percentage);
      this.http
        .post(this.url + '/saveQuestions', body)
        .subscribe((res: any) => {
          console.log(res);
        });
    }
  }

  checkUserRoles(result: any) {
    if (result.userRole === 'Admin') {
      this.router.navigate(['hg-admin']);
    } else {
      this.recommendationService.userName = result.questionStatusObj
        ? result.questionStatusObj.userName
          ? result.questionStatusObj.userName
          : null
        : null;
      this.residentialService.setUser({
        userName: result.userName,
        accountId: result.hg_accountId,
        emailId: result.userDetails.emailId,
      });
      this.residentialService.userResponse.userResponses = result.userResponses;
      this.residentialService.questionnaireStatusObj = result.questionStatusObj;
      this.residentialService.filter(result.userResponses);
      this.residentialService.currentId = result.questionStatusObj.questionStep;
      this.residentialService.messageService({
        nextId: result.questionStatusObj.questionStep,
        questionStatus: result.questionStatusObj.questionStatus,
        responses: result.userResponses,
      });
      this.getSelectedProductDetails();
    }
  }
  getSelectedProductDetails() {
    const body = new HttpParams();
    const user = {
      hg_accountId: this.hgAccountID,
    };
    this.residentialService
      .getSelectedProductDetails(user)
      .subscribe((res: any) => {
        this.recommendationService.signupProduct = res[0];
        this.router.navigate(['signuporder', this.hgAccountID]);
      });
  }
  setAdminTitle(userRole: any) {
    if (userRole === 'Admin') this.title.setTitle('Admin Dashboard');
  }

  getAuthenticate(url) {
    // questionarie object
    const questionnarieObj = this.residentialService.userResponse;
    const body = new HttpParams();
    const questionStatusObj = sessionStorage.getItem('questionStatusObj');
    sessionStorage.setItem('questionStatusObj', questionStatusObj);
    body.append('a', 'external');
    body.append('questionnarieObj', JSON.stringify(questionnarieObj));
    if (sessionStorage.getItem('signupProduct')) {
      body.append('type', JSON.stringify('signup'));
    } else {
      body.append('type', JSON.stringify('login'));
      sessionStorage.setItem('userResponse', JSON.stringify(questionnarieObj));
    }

    this.http
      .post(this.url + '/getUserResponse', body)
      .subscribe((res: any) => {
        const result = res;
        window.location.href = environment.api_url + url;
      });
  }

  closebtn() {
    window.history.back();
  }
  showForgotModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.forgotModalVisible = true;
  }
}
